import { getCurrentUser } from 'vuefire'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = await getCurrentUser()
  const userStore = useUserStore()
  if (to.name === 'VideoCallExternal') return
  if (to.name === 'mobile') return
  if (user) {
    const token = await user.getIdToken()
    if (token !== userStore.token) userStore.save(user, token)
  }
})
